import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Flags } from 'react-feature-flags'

import Modal from './Modal'
import { setDialog as setDialogConnect } from '../../actions/navigation'

const Disclaimer = ({ setDialog, isLoggedIn }) => {
    const loginRedirect = isLoggedIn ? '' : 'signIn'

    return (
        <>
            <Modal escapable={false}>
                <header>
                    <h2>Disclaimer</h2>
                </header>
                <p>
                    You are about to access Site Check. This informational tool is provided by the State of California
                    as a public service. The State of California makes no warranties as to accuracy of the underlying
                    data. Any determinations made by the tool should be independently verified. Nothing on this website
                    or in accompanying documents or links should be construed as legal advice.
                </p>
                <p>
                    By clicking <strong>Continue</strong>, you acknowledge that your use of this tool is for
                    informational purposes only.
                </p>
                <button type="button" className="button is-primary" onClick={() => setDialog(loginRedirect)}>
                    Continue{!isLoggedIn && ' as logged in user'}
                </button>
                {!isLoggedIn && (
                    <button type="button" className="button is-neutral" onClick={() => setDialog('')}>
                        Continue as guest
                    </button>
                )}
            </Modal>
        </>
    )
}

Disclaimer.propTypes = {
    // redux state
    isLoggedIn: PropTypes.bool.isRequired,
    // redux actions
    setDialog: PropTypes.func.isRequired
}

export default connect(
    ({ account: { email } }) => ({
        isLoggedIn: !!email
    }),
    dispatch => ({ setDialog: dialogName => dispatch(setDialogConnect(dialogName)) })
)(Disclaimer)
